"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Button, Link, List, ListItem } from "../../../atom";
import { BASE_CLASS } from "../Footer";
import css from "../Footer.module.css";

const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const FooterMenu = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleCmp = () => {
    const event = new CustomEvent("open-cmp");
    document.dispatchEvent(event);
  };

  return (
    <List
      orientation="horizontal"
      className={css[`${BASE_CLASS}-menu`]}
      ariaLabel="Menú enlaces del footer"
    >
      <ListItem hideIcon>
        <Button design="link" onClick={handleCmp}>
          Configurar cookies
        </Button>
      </ListItem>
      <ListItem hideIcon>
        <Link href="/privacy">Política de privacidad</Link>
      </ListItem>
      {!isProduction && (
        <ListItem hideIcon>
          <Link href="/drafts">Ver drafts</Link>
        </ListItem>
      )}
    </List>
  );
};
